import { render, staticRenderFns } from "./singleTopic.vue?vue&type=template&id=86597b04&scoped=true"
import script from "./singleTopic.vue?vue&type=script&lang=js"
export * from "./singleTopic.vue?vue&type=script&lang=js"
import style0 from "./singleTopic.vue?vue&type=style&index=0&id=86597b04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86597b04",
  null
  
)

export default component.exports